// ENABLE-FLOW
export const AUTO_RENEWAL_ENABLE_FLOW_PAGE_ONE: object = {
  flow_slug: 'enableRenewalFlagFlow',
  flow_version: 1,
  uuid: 'enable-rf-page-one',
  heading: 'Turn on automatic renewal',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Turn on automatic renewal'
  },
  sections: [
    {
      uuid: 'reminder-section-page-1',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        info: '',
        heading: 'Your policy will not automatically renew and will expire on {policyEndDate}'
      }
    },
    {
      uuid: 'helper-section-page-1',
      subtext: 'Don\'t worry, We will notify you when your policy is ready for renewal but ensure you switch this on before the date set out above if you would like to stay insured.',
      layout: '',
      settings: {
        card: true,
        hero: 'management-renewal'
      },
      heading: 'Renewal reminder'
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'enable-rf-page-one' }
  },
  human: {},
  progress: 1,
  total_pages: 2,
  actions: {
    back: {
      label: 'something else'
    }
  },
  analytics: {
    flow_slug: 'enableRenewalFlow',
    flow_version: 1,
    page_uuid: 'disable-rf-page-one'
  }
};

export const AUTO_RENEWAL_ENABLE_SUCCESS_PAGE: object = {
  flow_slug: 'SuccessRenewalFlagFlow',
  flow_version: 1,
  uuid: 'auto-renewal-success-page',
  heading: 'Automatic renewal has been turned on',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Return to dashboard'
  },
  sections: [
    {
      uuid: 'reminder-section-success',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        type: 'success',
        heading: '',
        content: 'Your policy will automatically renew on {policyEndDate}'
      }
    },
    {
      uuid: 'helper-section-success',
      subtext: 'We\'ll renew your policy automatically, keeping you covered without any gaps. Don\'t worry, We will also notify you when your policy is ready for renewal.',
      layout: '',
      settings: {
        card: true,
        hero: 'management-renewal'
      },
      heading: 'It\'s all sorted'
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'auto-renewal-success-page' }
  },
  human: {},
  progress: 2,
  total_pages: 2,
  analytics: {
    flow_slug: 'enableRenewalFlagFlow',
    flow_version: 1,
    page_uuid: 'auto-renewal-success-page'
  }
};

// DISABLE-FLOW
export const AUTO_RENEWAL_DISABLE_FLOW_PAGE_ONE: object = {
  flow_slug: 'disableRenewalFlagFlow',
  flow_version: 1,
  uuid: 'disable-rf-page-one',
  heading: 'Turn off automatic renewal',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Turn off automatic renewal'
  },
  sections: [
    {
      uuid: 'reminder-section-page-1',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        heading: 'Your policy will automatically renew on {policyEndDate}'
      }
    },
    {
      uuid: 'helper-section-page-1',
      subtext: 'We\'ll send you a reminder before the renewal date with all the details you need to stay protected without interruption.',
      layout: '',
      settings: {
        card: true,
        hero: 'management-renewal'
      },
      heading: 'Renewal reminder'
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'disable-rf-page-one' }
  },
  human: {},
  actions: {
    back: {}
  },
  progress: 1,
  total_pages: 3,
  analytics: {
    flow_slug: 'disableRenewalFlow',
    flow_version: 1,
    page_uuid: 'disable-rf-page-one'
  }
};

export const AUTO_RENEWAL_DISABLE_FLOW_PAGE_TWO = {
  flow_slug: 'disableRenewalFlagFlow',
  flow_version: 1,
  uuid: 'disable-rf-page-two',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Turn off automatic renewal'
  },
  heading: 'Are you sure you\'d like to turn off automatic renewal?',
  sections: [
    {
      uuid: 'reminder-section-page-2',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        type: 'warning',
        heading: '',
        content: 'If you turn off automatic renewal, your {productClass} insurance will expire on {policyEndDate}. You\'ll need to take action before this date to stay protected.'
      }
    },
    {
      uuid: 'helper-section-page-2',
      subtext: '<h2>Here\'s what happens next if you turn off automatic renewal</h2>\r\n<ul>\r\n  <li>Your policy will continue normally until {policyEndDate}</li>\r\n  <li>You can turn automatic renewal back on anytime up to 48 hours before your policy ends </li>\r\n  <li>We\'ll send you a reminder before expiry so you can make arrangements to stay covered</li>\r\n</ul>',
      layout: '',
      settings: {
        card: true,
        hero: 'management-emergencyhelp'
      },
      heading: ''
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'disableRenewalFlagFlow'
    }
  },
  human: {},
  progress: 2,
  total_pages: 3,
  actions: {
    back: {}
  },
  covers: [],
  analytics: {
    flow_slug: 'disableRenewalFlow',
    flow_version: 1,
    page_uuid: 'disable-rf-page-two'
  }
};

export const AUTO_RENEWAL_DISABLE_SUCCESS_PAGE: object = {
  flow_slug: 'SuccessRenewalFlagFlow',
  flow_version: 1,
  uuid: 'auto-renewal-success-page',
  heading: 'Automatic renewal has been turned off',
  subtext: '',
  layout: '',
  settings: {
    align: 'center',
    submit_label: 'Return to dashboard'
  },
  sections: [
    {
      uuid: 'reminder-section-success',
      subtext: '',
      layout: '',
      settings: {},
      heading: '',
      info: {
        type: 'warning',
        heading: '',
        content: 'Your policy will not automatically renew and will expire on {policyEndDate}'
      }
    },
    {
      uuid: 'helper-section-success',
      subtext: 'We\'ll send you a reminder when it\'s time to renew so you can take action to stay covered. If you\'ve changed your mind, you can turn automatic renewal back on anytime up to 48 hours before your policy ends.',
      layout: '',
      settings: {
        card: true,
        hero: 'management-renewal'
      },
      heading: 'In case you change your mind'
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'disable-rf-page-one' }
  },
  human: {},
  progress: 3,
  total_pages: 3,
  actions: {
    next: {
      label: 'return to dashboard',
      method: 'GET',
      url: 'dashboard/'
    }
  },
  analytics: {
    flow_slug: 'disableRenewalFlow',
    flow_version: 1,
    page_uuid: 'disable-rf-page-one'
  }
};

// UNDEFINED-ERROR
export const AUTO_RENEWAL_ERROR_PAGE: object = {
  flow_slug: 'RenewalFlagErrorFlow',
  flow_version: 1,
  uuid: 'auto-renewal-error-page',
  heading: 'Something went wrong',
  subtext: '',
  layout: '',
  settings: {},
  sections: [
    {
      uuid: 'reminder-section-page-1',
      subtext: 'Apologies, something went wrong',
      layout: '',
      settings: {
        card: true,
        hero: 'management-renewal'
      },
      heading: '',
      info: {
        type: 'String',
        heading: 'It\'s not you, please contact us'
      }
    }
  ],
  data: {
    _flow_metadata: { current_page_uuid: 'auto-renewal-error-page' }
  },
  human: {},
  progress: 0,
  total_pages: 1,
  analytics: {
    flow_slug: 'RenewalFlagErrorFlow',
    flow_version: 1,
    page_uuid: 'auto-renewal-error-page'
  }
};

